import api from '@/api/api'
import router from '@/router/index'
import { normalize, schema } from 'normalizr'

export const texto = new schema.Entity('texto', {}, { idAttribute: 'clave' })

export default {
  namespaced: true,
  state: {
    list: {},
    loading: false
  },
  mutations: {
    setAll (state, payload) {
      state.list = Object.assign({}, payload)
    },
    unload (state) {
      state.list = {}
    },
    loading (state, payload) {
      state.loading = payload
    }
  },
  actions: {
    loadAll ({ commit, dispatch }, currentRoute) { // Devuelve todas las promociones
      return new Promise((resolve, reject) => {
        api.get('/textos/get_lista', {
        })
          .then(response => {
            if (response.data.result.ok) {
              let normalizedData = normalize(response.data.result.data.data.textos, [texto])
              commit('setAll', normalizedData.entities.texto)
              commit('login/setIdioma', response.data.result.data.data.idioma, {root: true})
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  if (currentRoute.startsWith('incrustado')) {
                    router.push({ name: 'login.mensajeErrorAcceso' })
                  } else {
                    dispatch('alerts/addNotLoggedIn', null, { root: true })
                    router.push({ name: 'login' })
                  }
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    modificar ({ commit, dispatch }, obj) {
      return new Promise((resolve, reject) => {
        api.post('/textos/modificar', {
          jsondata: JSON.stringify({
            parametros: obj
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              let normalizedData = normalize(response.data.result.data.data, [texto])
              commit('setAll', normalizedData.entities.texto)
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    unload ({ commit }) {
      commit('unload')
    },
    setLoading ({commit}, payload) {
      commit('loading', payload)
    }
  },
  getters: {
    getAll (state) {
      return Object.keys(state.list).map(id => state.list[id])
    },
    getById (state) {
      return id => state.list[id]
    },
    getTexto (state, getters, rootState, rootGetters) {
      return (id, codigoPromocion, params) => {
        let t = getters.getById(id)
        if (codigoPromocion != null && t != null) {
          let tPromo = t.textosPromocion.find(x => x.codigoPromocion == codigoPromocion)
          if (tPromo != null) {
            t = tPromo
          }
        }
        if (t != null) {
          let i = t.idiomas.find(x => x.codigoIdioma === rootGetters['login/getIdioma'])
          if (i != null) {
            t = i.valor
          }
        }
        if (params != null && t != null) {
          for (const [key, value] of Object.entries(params)) {
            t = t.replace('{{' + key + '}}', value)
          }
        }
        return t
      }
    },
    textoTienePromocion (state, getters) {
      return (id, codigoPromocion) => {
        let t = getters.getById(id)
        return t != null ? t.textosPromocion.find(x => x.codigoPromocion == codigoPromocion) != null : false
      }
    },
    loaded (state, getters) {
      return getters.getAll.length > 0
    },
    loading (state) {
      return state.loading
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/textos/store.js